<template>
  <div>
    <slot />
  </div>
</template>

<script>
export default {
  name: "InBody",
  props:{
    autoRender:{
      type:Boolean,
      default:true
    }
  },
  methods:{
    renderElement(dom){
      const node = this.$mount().$el
      dom?dom.appendChild(node):document.body.appendChild(node)
    },
    removeElement(dom){
      dom?dom.remove():this.$mount().$el.remove()
    }
  },
  mounted() {
    this.autoRender && this.renderElement()
  },
  
  destroyed() {
    this.removeElement()
  }
}
</script>

<style scoped>

</style>